<section>

  <!-- CLOSE BUTTON -->
  <button type="button" class="close-button m-2" mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  @if (typZobrazovanychDat === TYP_DAT_PROFILOVE_PREDMETY) {
    <h3 mat-dialog-title class="ms-2">{{title}}</h3>
  } @else {
    <h3 mat-dialog-title class="ms-1" i18n>Výber predmetov</h3>
  }

  <!-- @if (typZobrazovanychDat === OSTATNY_PREDMET) {
    <div class="h5 odsadenie-nazvu" i18n>Zabezpečované predmety</div>
  } -->

  <div class="d-flex flex-row mb-1 justify-content-center align-items-center pe-5">
    <div class="me-2 text-center mat-body-1" i18n>Akademický rok</div>
    <div class="ms-1">
      <mat-form-field class="my-form-field akRok text-center" appearance="outline">
        <mat-select
          [matTooltip]="getAkademickyRokTooltip()"
          panelClass="mySelectedPanel"
          [(ngModel)]="akRok"
          (ngModelChange)="onAkRokComboboxChange()">
          <mat-option *ngFor="let item of akRoky" [value]="item">
            {{item}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>



  @if (typZobrazovanychDat === TYP_DAT_PROFILOVE_PREDMETY) {

    @if (isLoading()) {
      <p class="p-4" i18n>Načítavam predmety...</p>
    } @else if (predmetyPole().length > 0) {

        <mat-dialog-content class="mat-typography m-auto">

          <div class="row">

            <div class="col-check ps-1">
            </div>
            <div class="col-2 h6">
                <span i18n>Kód predmetu</span>
            </div>
            <div class="col-4 h6">
                <span i18n>Názov predmetu</span>
            </div>
            <div class="col-3 h6 text-center">
                <span i18n>Skratka štud. programu</span>
            </div>
            <div class="col-2 h6 text-center">
                <span i18n>Stupeň</span>
            </div>

          </div>

            @for (predmet of predmetyPole(); track predmet.kod) {

              <div class="row align-items-baseline mb-1"
                style="cursor: pointer;"
                [ngClass]="{'bg-body-secondary': predmet.vybrany, 'bg-white': !predmet.vybrany}"
                (click)="toggleRiadok(predmet)"
                [class.disabled-overlay]="isLoading()">

                <div class="col-check ps-1">
                  <mat-checkbox
                    [checked]="predmet.vybrany"
                    style="pointer-events: none;">
                  </mat-checkbox>
                </div>
                <div class="col-2">
                  {{predmet.kod}}
                </div>
                <div class="col-4">
                  {{getNazovPredmetu(predmet, kodJazykFormulara)}}
                </div>
                <div class="col-3 text-center">
                  {{predmet.studProgramySkratky}}
                </div>
                <div class="col-2 text-center">
                  {{predmet.studProgramStupen}}
                </div>

              </div>

            }

        </mat-dialog-content>

    } @else {
      <div class="d-flex justify-content-center">
        <div  class="p-4 h5 alert alert-danger upozornenie" i18n>
          Neboli nájdené žiadne predmety
        </div>
      </div>
    }



  } @else {

     <!-- verzia dialogu pre OSTATNE PREDMETY + PROFILOVE PREDMETY pod nimi -->

    @if (isLoading()) {
      <p class="p-4" i18n>Načítavam predmety...</p>
    } @else if (ostatnePredmetyPole().length > 0 || profilovePredmetyPole().length > 0) {

        <div class="dialog-double-content ms-4 me-4">

          <div class="section section-large">

            <h3 class="section-title" i18n>Zabezpečované predmety</h3>
            <mat-dialog-content>

              <div class="row">

                <div class="col-check ps-1">
                </div>
                <div class="col-2 h6">
                    <span i18n>Kód predmetu</span>
                </div>
                <div class="col-4 h6">
                    <span i18n>Názov predmetu</span>
                </div>
                <div class="col-3 h6 text-center">
                    <span i18n>Skratka štud. programu</span>
                </div>
                <div class="col-2 h6 text-center">
                    <span i18n>Stupeň</span>
                </div>

              </div>



              @for (predmet of ostatnePredmetyPole(); track $index) {

                <div class="row align-items-baseline mb-1"
                  style="cursor: pointer;"
                  [ngClass]="{'bg-body-secondary': predmet.vybrany, 'bg-white': !predmet.vybrany}"
                  (click)="toggleRiadok(predmet)"
                  [class.disabled-overlay]="isLoading()">

                  <div class="col-check ps-1">
                    <mat-checkbox
                      [checked]="predmet.vybrany"
                      style="pointer-events: none;">
                    </mat-checkbox>
                  </div>
                  <div class="col-2">
                    {{predmet.kod}}
                  </div>
                  <div class="col-4">
                    {{getNazovPredmetu(predmet, kodJazykFormulara)}}
                  </div>
                  <div class="col-3 text-center">
                    {{predmet.studProgramySkratky}}
                  </div>
                  <div class="col-2 text-center">
                    {{predmet.studProgramStupen}}
                  </div>

                </div>

              }

            </mat-dialog-content>
          </div>

          <hr class="separator" />

          <div class="section section-small">

            <h3 class="section-title" i18n>Profilové predmety</h3>
            <mat-dialog-content>

              <div class="row">

                <div class="col-check ps-1">
                </div>
                <div class="col-2 h6">
                    <span i18n>Kód predmetu</span>
                </div>
                <div class="col-4 h6">
                    <span i18n>Názov predmetu</span>
                </div>
                <div class="col-3 h6 text-center">
                    <span i18n>Skratka štud. programu</span>
                </div>
                <div class="col-2 h6 text-center">
                    <span i18n>Stupeň</span>
                </div>

              </div>

              @for (predmet of profilovePredmetyPole(); track predmet.kod) {

                <div class="row align-items-baseline mb-1"
                  style="cursor: pointer;"
                  [ngClass]="{'bg-body-secondary': predmet.vybrany, 'bg-white': !predmet.vybrany}"
                  (click)="toggleRiadok(predmet)"
                  [class.disabled-overlay]="isLoading()">

                  <div class="col-check ps-1">
                    <mat-checkbox
                      [checked]="predmet.vybrany"
                      style="pointer-events: none;">
                    </mat-checkbox>
                  </div>
                  <div class="col-2">
                    {{predmet.kod}}
                  </div>
                  <div class="col-4">
                    {{getNazovPredmetu(predmet, kodJazykFormulara)}}
                  </div>
                  <div class="col-3 text-center">
                    {{predmet.studProgramySkratky}}
                  </div>
                  <div class="col-2 text-center">
                    {{predmet.studProgramStupen}}
                  </div>

                </div>

              }


            </mat-dialog-content>
          </div>

        </div>

      } @else {

        <div class="d-flex justify-content-center">
          <div  class="p-4 h5 alert alert-danger upozornenie">
            <span i18n>Neboli nájdené žiadne predmety</span>
          </div>
        </div>

    }


  }

  @if (predmetyPole().length >= maxPocetPredmetov) {
    <div class="fw-bold fst-italic fs-6 ms-4 mt-4">
      <span i18n>Maximálny počet je</span> {{maxPocetPredmetov}}
    </div>
  }

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close i18n>Zrušiť</button>
    <button mat-stroked-button cdkFocusInitial
      i18n (click)="onConfirm()">Potvrdiť</button>
  </mat-dialog-actions>

</section>
